<template>
  <div class="page-wrapper">
    <div class="background-page">

      <div style="width: 100%; height: 100%; overflow-y: auto">
      <template v-if="product != false">
        <div style="padding:10px 0 10px 0; font-weight: bold; font-size: 20px;">{{product.name}}</div>
        <div style="padding: 10px; background-color: #F4F4F4; text-align: left;">{{product.description}}</div>
        <div v-if="product.youtube != undefined && product.youtube != null && product.youtube.length > 0" class="youtube-container">
          <iframe :src="product.youtube"  frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
        <div v-if="product.contentImages != null && product.contentImages.length > 0">
          <img v-for="img in product.contentImages" :src="img" style="width: 100%; margin-top:10px;margin-bottom: 10px;"/>
        </div>

        <div style="padding: 20px; text-align: center; font-weight: bold; font-size: 20px;"><span style="background-color: #FF8B7F; color:white; padding:10px 20px 10px 20px; border-radius: 20px; box-shadow: 3px 3px 5px grey;"> £{{Number(product.price).toFixed(2)}}</span></div>
        <div style="padding:10px 0 10px 0; font-weight: bold; font-size: 12px; text-align: center;">UK Registered, {{product.reg}}</div>
        <div class="no-tnc">
          <Bottom
            :item="merchant">

          </Bottom>
        </div>
      </template>
      </div>
    </div>
  </div>

</template>

<script>
    import {getProduct} from "../api/borium";
    import Bottom from "./Bottom";

    export default {
        name: "Product",
      components: {
        Bottom
      },
      data() {
          return {
            product:false,
            merchant:false,
          }
      },
      created() {
      },
      mounted() {
        if(this.$route.params.hasOwnProperty('id')) {
            this.loadProductData(this.$route.params.id);
          }
      },
      beforeDestroy() {
      },
      methods: {
          loadProductData: function(pid) {
            let self = this;
            getProduct(pid)
            .then(function(data) {
              if(data.success == true) {
                if(data.item.contentImages != null && data.item.contentImages.length > 0) {
                  data.item.contentImages = data.item.contentImages.split(',');
                } else {
                  data.item.contentImages = [];
                }
                self.$data.product = data.item;
                if(data.merchant.imageUrl != null && data.merchant.imageUrl.length > 0) {
                  data.merchant.imageUrl = data.merchant.imageUrl.split(',');
                } else {
                  data.merchant.imageUrl = [];
                }
                self.$data.merchant = data.merchant;
              } else {

              }
            })
            .catch(function(err) {

            })
          }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Product.vue